import { Controller } from "@hotwired/stimulus"
import {Cloudinary, Transformation, transformationStringFromObject} from "@cloudinary/url-gen"
import { source } from "@cloudinary/url-gen/actions/overlay";
import {text} from "@cloudinary/url-gen/qualifiers/source";
import { Position } from "@cloudinary/url-gen/qualifiers/position";
import {set, setString} from "@cloudinary/url-gen/actions/variable";
import {compass} from "@cloudinary/url-gen/qualifiers/gravity";
import {Conditional} from "@cloudinary/url-gen/actions/conditional";
import { fetch, image } from "@cloudinary/url-gen/qualifiers/source";
import {fill, fit, Resize} from '@cloudinary/url-gen/actions/resize';
import {TextStyle} from "@cloudinary/url-gen/qualifiers/textStyle";


// Connects to data-controller="card-canvas"
export default class extends Controller {

  static targets = ["col",'imgInput', 'uploadButton', 'imgCutlines','imgPlain', 'zoomToggle','zoomFields',
    'zoomAmount', 'backgroundColor', 'cutsCheckbox', 'qrToggle', 'qrFields', 'qrUrlInput', 'qrCtaInput', 'qrFontInput',
    'qrColorInput' , 'qrWarn']

  static values = { formFactor: String, orientation: String, faceIndex: Number , isProcessing: Boolean, showCuts: Boolean, faceDimensions: Array, faceInnerDimensions: Array };
  connect() {}
  initialize() {
    this.cld = new Cloudinary({
      cloud: {
        cloudName: 'dxyn6zcjc'
      },
      url: {
        secure: true // force https, set to false to force http
      }
    });
  }

  orientationValueChanged() {
    this.updateImage()
    if(this.isLandscape()){
      this.colTarget.classList.remove("col-6")
      this.colTarget.classList.add("col-8")
    }else{
      this.colTarget.classList.remove("col-8")
      this.colTarget.classList.add("col-6")
    }

  }
  isProcessingValueChanged() {
    if(this.isProcessingValue){
      this.uploadButtonTarget.classList.add("disabled")
    }else{
      this.uploadButtonTarget.classList.remove("disabled")
    }
  }
  startProcessing(){
    this.isProcessingValue = true
  }
  stopProcessing(){
    this.isProcessingValue = false
  }
  isJumboPostcard(){
    return this.formFactorValue === 'jumbo_postcard'
  }
  isLandscape(){
    return this.orientationValue === "landscape"
  }
  isCardBack(){
    return this.faceIndexValue === 1
  }

  imgPk(){
    if(this.imgInputTarget.value.length > 0){
      return this.imgInputTarget.value
    }else{
      return this.clearPxl()
    }
  }


  // Zoom & Bleed
  toggleZoom(){
    const fullBleed = this.zoomToggleTarget.checked
    if(fullBleed){
      this.zoomFieldsTarget.classList.add("d-none")
    }else{
      this.zoomFieldsTarget.classList.remove("d-none")
    }
    this.updateImage()
  }
  isFullBleed(){
    return this.zoomToggleTarget.checked
  }
  imageZoomAmount(){
    const zoomAmount = this.zoomAmountTarget.value
    return zoomAmount * 900
  }

  //QR Code
  //

  displayQrCode(){
    return  this.qrToggleTarget.checked && this.hasQrUrl()
  }
  toggleQrPane(){
    const isChecked = this.qrToggleTarget.checked
    if(isChecked){
      this.qrFieldsTarget.classList.remove("d-none")
    }else{
      this.qrFieldsTarget.classList.add("d-none")
    }
  }
  qrCodeUrl(){
    return this.qrUrlInputTarget.value.trim()
  }
  hasQrUrl(){
    return this.qrCodeUrl().length > 0
  }
  async updateQr(){
    let url = this.qrCodeUrl()
    const MAX_URL_LENGTH = 100 //length prior to second encoding
    if(this.hasQrUrl()){
      if(!url.startsWith("http://") && !url.startsWith("https://")) {
        url = "https://" + url
        this.qrUrlInputTarget.value = url
      }
      const domain = 'https://live.simplynoted.com'
      const encoded_qr_url = this.base64URLencode(url)
      let request_url = domain + "/barcode?url=" + encoded_qr_url
      this.qrWarnTarget.classList.add("d-none")
      if(request_url.length > MAX_URL_LENGTH ){
        const placeholderUrl = this.base64URLencode("https://www.simplynoted.com")
        request_url = domain + "/barcode?url=" + placeholderUrl
        this.qrWarnTarget.classList.remove("d-none")
      } else{
        console.log("short url")
      }

      this.qrUrlInputTarget.dataset.qrPublicId = ""
      this.qrUrlInputTarget.dataset.qrFetchUrl = request_url
      this.updateImage()
    }
  }

  hasQrPublicId(){
   return this.qrPublicId().length > 0
  }
  qrPublicId(){
    return this.qrUrlInputTarget.dataset.qrPublicId
  }
  qrFetchUrl(){
    return this.qrUrlInputTarget.dataset.qrFetchUrl
  }
  qrCtaText(){
    return this.qrCtaInputTarget.value.trim()
  }
  hasQrCtaText(){
    return this.qrCtaText().length > 0
  }
  qrCtaFont(){
    return this.qrFontInputTarget.value
  }
  qrCtaColor(){
    return this.qrColorInputTarget.value
  }
  toggleCuts(){
    console.log("toggleCuts")
    this.showCutsValue = !this.showCutsValue
    if(this.showCutsValue){
      this.imgCutlinesTarget.classList.remove("d-none")
      this.imgPlainTarget.classList.add("d-none")
    }else{
      this.imgCutlinesTarget.classList.add("d-none")
      this.imgPlainTarget.classList.remove("d-none")

    }
  }

  updateImage(){
    this.startProcessing()
    const public_id = this.imgPk()
    let cutLineImage =this.cutWrap(public_id, [], false, true)

    this.preloadImage(this.imgCutlinesTarget, cutLineImage.toURL())
    const plainImage =this.cutWrap(public_id, [], false, false)
    this.preloadImage(this.imgPlainTarget, plainImage.toURL())
  }
  preloadImage(imgTarget, src){
    const preloader = new Image();
    preloader.onload = () => {
      imgTarget.src = preloader.src;
      this.stopProcessing()
    };
    preloader.onerror = (err) => {
      console.error('Failed to load image:', err);
      this.stopProcessing()
    };
    preloader.src = src;

  }

  qrOverlay(){
    if(this.isJumboPostcard()){
      return this.qrPanePostcardTransforms()
    }else{
      return this.qrPaneA7Transforms()
    }
  }

  qrPanePostcardTransforms(){
    let xforms = []
    const qr_text_width = 800
    const qr_gutter = 25
    const qr_pane_width_px = 266 + qr_text_width + qr_gutter
    const xOffset = Math.trunc(qr_pane_width_px / 2.0 + 200)

    xforms.push( {overlay: "system:pxl",  crop: "fill", height: 266, width: qr_pane_width_px})

    if(this.displayQrCode()){
      if(this.hasQrPublicId()){
        xforms.push(
          { overlay: this.qrPublicId() },
          { flags: "layer_apply", gravity: "west" }
        );
      }else{
        xforms.push(
          { overlay: {url: this.qrFetchUrl()} },
          { flags: "layer_apply", gravity: "west" }
        );
      }
    }

    if(this.hasQrCtaText()){
      xforms.push(  {color: this.qrCtaColor(), background: 'white' , //Must have background color to render correctly
        overlay: {font_family: this.qrCtaFont(), font_size: 50,
          font_weight: "bold", text: this.qrCtaText() , text_align: 'left'},
        width: qr_text_width, crop: "fit" },
        {flags: "layer_apply", gravity: "east"})
    }

    xforms.push({flags: "layer_apply", gravity: "north", y: 100, x: xOffset  })

    return xforms
  }

  qrPaneA7Transforms(){
    const yoffset = this.isLandscape() ?  38 : 0
    const xOffset = this.isLandscape() ?  0 : 38
    const qrTextWidth = 400
    let xforms = []

    xforms.push({ overlay: "system:pxl", crop: "fill", width: qrTextWidth });

    if (this.displayQrCode()) {
      if(this.hasQrPublicId()){
        xforms.push(
          { overlay: this.qrPublicId() },
          { flags: "layer_apply", gravity: "north", y: 150 - yoffset }
        );
      }else{
        xforms.push(
          { overlay: {url: this.qrFetchUrl()} },
          { flags: "layer_apply", gravity: "north", y: 150 - yoffset }
        );
      }
    }

    if (this.hasQrCtaText()) {
      xforms.push(
        {
          color: this.qrCtaColor(),
          background: "transparent",
          overlay: {
            font_family: this.qrCtaFont(),
            font_size: 50,
            font_weight: "bold",
            text: this.qrCtaText(),
            text_align: "center",
          },
          width: qrTextWidth,
          crop: "fit",
        },
        { flags: "layer_apply", gravity: "north", y: 448 - yoffset } //488
      );
    }
    xforms.push({ flags: "layer_apply", gravity: "north" , x: xOffset}); // x: 37
    return xforms
  }



  cutWrap(upload_id, apply_as_layer_xforms = [] , print_ready_version = false , is_preview = false){
    let pk = this.clearPxl()

    let xforms =  []
    xforms.push(...[{crop: 'lpad', width: this.innerWidthPlusCutGuidesPx(), height: this.innerHeightPlusCutGuidesPx(),
                background: "white"}])
    xforms.push(...[{
      overlay: "system:pxl",
      crop: "fill",
      height: this.innerHeightPlusCutGuidesPx(),
      width: this.innerWidthPlusCutGuidesPx(),
      gravity: "north"
    }])
    xforms.push(...this.cutmarkTransforms())
    xforms.push(... this.renderPrimaryImage(upload_id,[{flags:"layer_apply",gravity: this.cardEdgeGravity()}],print_ready_version, is_preview))
    return this.asLayerOrUrl(pk, xforms, [])
  }
  renderPrimaryImage(upload_id, apply_as_layer_xforms = [] , print_ready_version = false , is_preview = false){
    const pk = upload_id
    let xforms = []

    // Layout
    if (this.isFullBleed()) {
      xforms.push(...[{crop: "fill", height: this.faceHeight(), width: this.faceWidth(), gravity: "center"}])
    }else {
      xforms.push(... [{crop: "scale", width: this.imageZoomAmount()}, {
        background: "rgb:FFFFFF",
        crop: "lpad",
        gravity: "center",
        height: this.faceHeight(),
        width: this.faceWidth()
      }])
    }
    // Stamp
    if(this.isJumboPostcard() && this.isCardBack()){
      xforms.push(...[{overlay: "stamp4x", width: 369 , background: "transparent"},
      {flags: "layer_apply", gravity: "north_east", x: 0, y: 75}])
    }
    // QR Code
    if(this.displayQrCode()||this.hasQrCtaText()){
      xforms.push(...this.qrOverlay())
    }

    // cut lines
    if(is_preview) {
      xforms.push(...[{
        overlay: "system:pxl",
        crop: "fill",
        height: this.innerFaceHeight(),
        width: this.innerFaceWidth(),
        gravity: "north"
      },
        {border: "5px_solid_red"}])
      xforms.push(... [{
        crop: "crop",
        gravity: this.invertGravity(this.cardEdgeGravity()),
        height: this.innerHeightPlusCutOffsetPx(),
        width: this.innerWidthPlusCutOffsetPx()
      }])
      xforms.push(... [{flags: "layer_apply", gravity: this.cardEdgeGravity()}])
    }

    return this.asLayerOrUrl(pk, xforms , apply_as_layer_xforms)
  }

  convertUrlToSlug(url){
    return url.replace('/',':')
  }

  printQualityXforms() {
    return [{quality: 100}, {density: 300}]
  }

  asLayerOrUrl(p_key, xforms=[], apply_as_layer_xforms=[]) {
    let layer = []


    if (apply_as_layer_xforms.length > 0) {
      layer = [{overlay: this.convertUrlToSlug(p_key)}]
      layer.push(...xforms)
      layer.push(...apply_as_layer_xforms)
      return layer
    } else{
      let myImage = this.cld.image(p_key)
      myImage.addTransformation(transformationStringFromObject(xforms))
      return myImage
    }
  }


  cutlineWidthPx(){
    return 5
  }
  cutguideWidthPx(){
    return 75
  }
  clearPxl(){
    return 'system/pxl'
  }

  invertGravity(gravity){
    switch (gravity) {
      case 'north':
        return 'south'
      case 'east':
        return 'west'
      case 'south':
        return 'north'
      case 'west':
        return 'east'
      case 'center': // center gravity does not change
        return 'center'
    }
  }

  cardEdgeGravity(){
    if(this.isJumboPostcard()){
      return 'center'
    }
    if(this.isLandscape()){
      return 'north'
    }
    if(this.isCardBack()){
      return 'east'
    }else{
      return 'west'
    }
  }
  cutlineOffset(){
    if(this.isJumboPostcard()){
      return  {x: 0, y: 0}
    }
    if(this.isLandscape()){
      return {y:-5}
    }
    return {x:5}
  }

  cutmarkTransforms(){
    if(this.isJumboPostcard()){
      return [
        { overlay: "cuts_right_top" }, { flags: "layer_apply", gravity: "north_east", },
        { overlay: "cuts_right" }, { flags: "layer_apply", gravity: "south_east", },
        { overlay: "cuts_left" }, { flags: "layer_apply", gravity: "south_west" },
        { overlay: "cuts_left_top" }, { flags: "layer_apply", gravity: "north_west" }
      ]
    }
    if(this.isLandscape()){
      return [
        { overlay: "cuts_right" }, { flags: "layer_apply", gravity: "south_east", },
        { overlay: "cuts_left" }, { flags: "layer_apply", gravity: "south_west" },
      ]
    }
    if(this.isCardBack()){
      return [
        { overlay: "cuts_left" }, { flags: "layer_apply", gravity: "south_west" },
        { overlay: "cuts_left_top" }, { flags: "layer_apply", gravity: "north_west" }
      ]
    }else{
      return [
        { overlay: "cuts_right_top" }, { flags: "layer_apply", gravity: "north_east", },
        { overlay: "cuts_right" }, { flags: "layer_apply", gravity: "south_east", },
      ]
    }
  }

  faceWidth(){
    if(this.isLandscape()){
      return Math.max(...this.faceDimensionsValue)
    }else{
      return Math.min(...this.faceDimensionsValue)
    }
  }
  faceHeight(){
    if(this.isLandscape()){
      return Math.min(...this.faceDimensionsValue)
    }else{
      return Math.max(...this.faceDimensionsValue)
    }
  }

  innerFaceWidth(){
    if(this.isLandscape()){
      return Math.max(...this.faceInnerDimensionsValue)
    }else{
      return Math.min(...this.faceInnerDimensionsValue)
    }
  }
  innerFaceHeight(){
    if(this.isLandscape()){
      return Math.min(...this.faceInnerDimensionsValue)
    }else{
      return Math.max(...this.faceInnerDimensionsValue)
    }
  }

  innerHeightPlusCutGuidesPx(){
    if(this.isLandscape() && !this.isJumboPostcard()){
      return this.innerFaceHeight() + this.cutguideWidthPx()
    }else{
      return this.innerFaceHeight() + this.cutguideWidthPx() * 2
    }
  }
  innerHeightPlusCutOffsetPx(){
    if(this.isLandscape() && !this.isJumboPostcard()){
      return this.innerFaceHeight()
    }else{
      return this.innerFaceHeight() + 10
    }
  }
  innerWidthPlusCutGuidesPx(){
    if(this.isLandscape()){
      return this.innerFaceWidth() + this.cutguideWidthPx() * 2
    }else{
      return this.innerFaceWidth() + this.cutguideWidthPx()
    }
  }
  innerWidthPlusCutOffsetPx(){
    if(this.isLandscape()){
      return this.innerFaceWidth()+ 10
    }else{
      return this.innerFaceWidth()
    }
  }


  cloudinarybase64EncodeURL(url){
    let encodedResult = btoa(encodeURI(url))
    return encodedResult.replace(/\+/g, '-') // Convert '+' to '-'
                        .replace(/\//g, '_'); // Convert '/' to '_';

  }

  base64URLencode(str) {
    const base64Encoded = btoa(str);
    return base64Encoded.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

}
